import { Link } from 'react-router-dom'
import { Package } from '../config/api'
import {
  getPackageDestination,
  getPackageImageUrl,
  formatTravelDates,
  PACKAGE_CARD_GRADIENTS,
} from '../utils/packageHelpers'

interface PackageCardProps {
  pkg: Package
  index?: number
}

export default function PackageCard({ pkg, index = 0 }: PackageCardProps) {
  const imageUrl = getPackageImageUrl(pkg)
  const destination = getPackageDestination(pkg)
  const dates = formatTravelDates(pkg.travel_from, pkg.travel_to, pkg.dates)
  const gradient = PACKAGE_CARD_GRADIENTS[index % PACKAGE_CARD_GRADIENTS.length]

  return (
    <Link to={`/packages/${pkg.slug}`} className="card-vaia">
      <div
        className="card-img"
        style={{
          backgroundImage: imageUrl ? `url(${imageUrl})` : gradient,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <span className="tag">{destination}</span>
      </div>
      <div className="card-body">
        <h3>{pkg.name}</h3>
        <div className="dates font-mono">{dates}</div>
        <div className="price">
          <span className="from">From</span>
          <span className="amt">{pkg.formatted_price}</span>
        </div>
      </div>
    </Link>
  )
}

export function PackageCardSkeleton() {
  return (
    <div className="card-vaia animate-pulse">
      <div className="card-img bg-line" />
      <div className="card-body">
        <div className="h-4 bg-line rounded w-2/3 mb-3" />
        <div className="h-3 bg-line rounded w-1/2 mb-4" />
        <div className="h-6 bg-line rounded w-1/3" />
      </div>
    </div>
  )
}
